package pt.at.oss.kotlin.pages.action

/**
 * Actions that can be performed on a NETP represented by an Intermediary.
 */
enum class IntNetpAction {
    SEE_DETAIL,
    REREGISTER,
    EDIT_REGISTO,
    EXCLUDE,
    ;
}
